export default __webpack_public_path__ + "static/media/hero-screenshot.d8aefe34.png";